<template>
  <v-container fluid>
    <v-card>
      <v-card-title primary-title>
        <h3 class="headline mb-0">月次運賃・諸掛請求</h3>
      </v-card-title>
      <v-card-actions>
        <!-- <v-btn
          @click="load()"
          class="btn-search"
          v-permit.SHARP_MS_SEARCH.SHARP_MD_SEARCH
        >{{$t('app.buttons.search')}}</v-btn>-->
        <!-- <v-btn @click="monthlyDeal" v-permit.SHARP_MS_MOUTH.SHARP_MD_MOUTH>月次処理</v-btn> -->
        <v-btn
          @click="monthlyDeal2"
          v-if="true"
          v-permit.SHARP_MS_MOUTH.SHARP_MD_MOUTH
          >月次処理</v-btn
        >
        <!-- <v-btn @click="monthlyDeal3" v-if="true" v-permit.SHARP_MS_MOUTH.SHARP_MD_MOUTH>月次処理-consume</v-btn> -->
        <!--
        <v-btn
          @click="monthlyDeal4"
          v-if="true"
          v-permit.SHARP_MS_MOUTH.SHARP_MD_MOUTH
        >月次処理-exception</v-btn>-->
        <!-- <v-btn @click="openMonth" v-permit.SHARP_MS_DOWNLOAD.SHARP_MD_DOWNLOAD>経理用データ作成</v-btn> -->
        <!-- <v-btn
          @click="download('AP')"
          v-if="true"
          v-permit.SHARP_MS_DOWNLOAD.SHARP_MD_DOWNLOAD
        >AP(支払)作成</v-btn>
        <v-btn
          @click="download('AR')"
          v-if="true"
          v-permit.SHARP_MS_DOWNLOAD.SHARP_MD_DOWNLOAD
        >AR(請求)作成</v-btn> -->
        <v-btn
          @click="downloadV2('ap_archive')"
          v-if="true"
          v-permit.SHARP_MS_DOWNLOAD.SHARP_MD_DOWNLOAD
          >AP(支払)作成_V2</v-btn
        >
        <v-btn
          @click="
            downloadV2('ap_archive', 'paymentDateType=OneToTwenty&isJusda=true')
          "
          v-if="true"
          v-permit.SHARP_MS_DOWNLOAD.SHARP_MD_DOWNLOAD
          >AP(支払)作成_JUSDA_1_20</v-btn
        >
        <v-btn
          @click="
            downloadV2(
              'ap_archive',
              'paymentDateType=TwentyOneToEnd&isJusda=true'
            )
          "
          v-if="true"
          v-permit.SHARP_MS_DOWNLOAD.SHARP_MD_DOWNLOAD
          >AP(支払)作成_JUSDA_21_月末</v-btn
        >
        <!-- <v-btn
          @click="downloadV2('ap_archive','isJusda=false&paymentDateType=international')"
          v-if="true"
          v-permit.SHARP_MS_DOWNLOAD.SHARP_MD_DOWNLOAD
        >AP(支払)作成_国际段非JUSDA</v-btn> -->
        <v-btn
          @click="downloadV2('ap_archive', 'isJusda=false')"
          v-if="true"
          v-permit.SHARP_MS_DOWNLOAD.SHARP_MD_DOWNLOAD
          >AP(支払)作成_非JUSDA</v-btn
        >
        <v-btn
          @click="downloadV2('ap_archive')"
          v-if="true"
          v-permit.SHARP_MS_DOWNLOAD.SHARP_MD_DOWNLOAD
          >AP(支払)作成_全量</v-btn
        >
        <v-btn
          @click="downloadV2('ar_archive')"
          v-if="true"
          v-permit.SHARP_MS_DOWNLOAD.SHARP_MD_DOWNLOAD
          >AR(請求)作成_V2</v-btn
        >
      </v-card-actions>
      <v-form>
        <v-container fluid>
          <v-layout>
            <v-flex md3 sm6 xs12>
              <date-picker
                label="月次"
                type="month"
                v-model="query.month"
              ></date-picker>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-card>

    <v-card class="mt-2" v-if="false">
      <v-card-title primary-title>
        <div>
          <span class="headline mb-0">検索結果表示</span>
        </div>
      </v-card-title>

      <v-card-actions>
        <!-- <v-btn to="/B1200" v-permit.SHARP_MD_SKU>品番別</v-btn> -->
        <v-btn disabled v-permit.SHARP_MD_BU>事業本部・事業部別</v-btn>
      </v-card-actions>

      <v-data-table
        :headers="headers"
        :items="pagination.content"
        :pagination.sync="pagination"
        :rows-per-page-items="[10]"
        :total-items="pagination.totalItems"
        class="elevation-0"
        item-key="id"
        select-all
        v-model="selected"
      >
        <template slot="items" slot-scope="props">
          <td>
            <v-checkbox
              :input-value="props.selected"
              hide-details
              primary
            ></v-checkbox>
          </td>
          <td>{{ props.item.buHeadquartersName }}</td>
          <td>{{ props.item.departmentName }}</td>
          <td>{{ props.item.freightFee }}</td>
          <td>{{ props.item.currencyCode }}</td>
          <td>{{ props.item.rate }}</td>
          <td>{{ props.item.importFee }}</td>
          <td>{{ props.item.domesticFare }}</td>
          <td>{{ props.item.otherFee }}</td>
          <td>{{ props.item.foreignCurrencyTotal }}</td>
          <td>{{ props.item.jpytotal }}</td>
        </template>
      </v-data-table>
    </v-card>

    <month-dialog :query="selected" ref="monthDialog"></month-dialog>
  </v-container>
</template>

<script>
import MonthDialog from './MonthDialog'
export default {
  components: {
    MonthDialog,
  },
  data() {
    return {
      query: {},
      selected: [],
      loading: true,
      month: null,
      showDeliveryOrders: [],
      headers: [
        { text: '事業本部', value: 'buHeadquartersName', sortable: false },
        { text: '事業部', value: 'departmentName', sortable: false },
        { text: 'フレイト費', value: 'freightFee', sortable: false },
        { text: '外貨', value: 'currencyCode', sortable: false },
        { text: 'レート', value: 'rate', sortable: false },
        { text: '輸入手数料', value: 'importFee', sortable: false },
        { text: '国内運賃', value: 'domesticFare', sortable: false },
        { text: 'その他', value: 'otherFee', sortable: false },
        { text: '外貨計', value: 'foreignCurrencyTotal', sortable: false },
        { text: 'JPY計', value: 'jpytotal', sortable: false },
      ],
      pagination: {
        page: 1,
      },
    }
  },
  methods: {
    check() {
      if (this.query.month == null) {
        this.$message(
          this.$t('app.messages.errors.title'),
          '年と月を選ぶ必要があります'
        )
        return false
      }
      return true
    },
    monthlyDeal3() {
      if (!this.check()) return
      return this.$http.put(`/reports/ARP/mock/generate-arps`).then((res) => {
        if (res.data) {
          this.$message(
            '',
            `${this.query.month} done! please wait a few minutes`
          )
          return
        }
      })
    },
    monthlyDeal2() {
      if (!this.check()) return

      return this.$http
        .put(`/reports/ARP/generate?yearMonth=${this.query.month}`)
        .then((res) => {
          if (res.data) {
            this.$message(
              '',
              `${this.query.month}のデータ作成完了、暫くお待ってください`
            )
            return
          }
        })
    },
    download(name) {
      if (!this.check()) return
      this.$http
        .get(`reports/ARP-detect?yearMonth=${this.query.month}`)
        .then((res) => {
          return this.$download(
            `/reports/${name}?yearMonth=${this.query.month}`
          )
        })
        .catch((res) => {
          if (res.response.status === 500) {
            console.log(res.response.data.message)
            if (res.response.data.message == 'ARP_NOT_READY') {
              this.$message(
                this.$t('app.messages.errors.title'),
                `${this.query.month}データは作成していない`
              )
            } else {
              this.$message(
                this.$t('app.messages.errors.title'),
                `system error, module:${this.$route.path}`
              )
            }
          }
        })
    },
    downloadV2(path, params) {
      return this.$download(
        `/reports/${path}?yearMonth=${this.query.month}&${params}`
      )
    },
    //合并数组
    combineBu() {
      this.pagination.content = this.showDeliveryOrders.reduce((t, l) => {
        var r = t.find((item) => item.departmentId === l.departmentId)
        if (!r) {
          t.push(l)
        } else {
          r.freightFee += l.freightFee
          r.importFee += l.importFee
          r.domesticFare += l.domesticFare
          r.foreignCurrencyTotal += l.foreignCurrencyTotal
          r.jpytotal += l.jpytotal
        }
        return t
      }, [])
    },
  },
  mounted() {
    this.$loadParams()
    //this.load()
  },
}
</script>
<style>
div.v-card div.v-card__title {
  padding: 8px;
}
div.v-menu__activator div.v-input {
  padding-top: 8px;
  padding-left: 8px;
}
</style>